import { Instagram, Youtube, Mail } from "lucide-react";

const Footer = () => (
  <footer className="border-t border-white/10 px-6 py-10 text-center">
    <p className="text-xs uppercase tracking-[0.2em] text-white/40">
      © {new Date().getFullYear()} dudu crespo · todos os direitos reservados
    </p>
    <div className="mt-5 flex items-center justify-center gap-6">
      <a
        href="https://www.instagram.com/duducrespo_/"
        target="_blank"
        rel="noopener noreferrer"
        className="text-white/50 transition-colors hover:text-white"
        aria-label="instagram"
      >
        <Instagram size={20} />
      </a>
      <a
        href="https://www.tiktok.com/@duducrespo__"
        target="_blank"
        rel="noopener noreferrer"
        className="font-mono text-xs uppercase tracking-[0.2em] text-white/50 transition-colors hover:text-white"
      >
        tiktok
      </a>
      <a
        href="https://www.youtube.com/@duducrespo"
        target="_blank"
        rel="noopener noreferrer"
        className="text-white/50 transition-colors hover:text-white"
        aria-label="youtube"
      >
        <Youtube size={20} />
      </a>
      <a
        href="https://duducrespo.substack.com"
        target="_blank"
        rel="noopener noreferrer"
        className="text-white/50 transition-colors hover:text-white"
        aria-label="newsletter"
      >
        <Mail size={20} />
      </a>
    </div>
  </footer>
);

export default Footer;
